import React from "react";
import Colors from "../../constants/Colors";
import ContactForm from "../contact/ContactForm";
import { useTranslation } from 'react-i18next';

const ContactFormServices = ({ color = Colors.white }) => {
  const { t } = useTranslation();

  const joinUs = t('join-us');
  return (
    <div className="card-contact-services-spacing container">
      <div className="row g-0 d-flex flex-column flex-xl-row">
        <div className="col">
          <div className="d-flex align-items-center h-100" style={{ color: color }}>
            <div className="mx-auto ms-xl-auto me-xl-0 mt-5">
              <div className="card-contact-services-container">
                <p className="card-contact-services-title fw-semibold fs-36 mb-xl-5">
                  {joinUs.title}
                </p>
                <span className="fs-18 fw-light pb-4 d-none d-xl-block">
                  {joinUs.description}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="col col-xl-5">
          <ContactForm />
        </div>
      </div>
    </div>
  );
};

export default ContactFormServices;
